import React from 'react';

import { getVersionDate } from './ExpertReferencePreview';
import { PlainReferenceChip } from './PlainReferenceChip';
import type { ReferenceTriggerProps } from './referenceKinds';

/**
 * A cited handler message or answered question: a chip with the handler's name, and the words and date on hover.
 * A message resolved without a name keeps the sentence's own link text.
 */
export const HumanReferenceTrigger: React.FC<ReferenceTriggerProps> = ({ reference, children }) => {
  const name = reference.name || children;

  return <PlainReferenceChip label={name} title={name} secondary={getVersionDate(reference)} body={reference.text} />;
};
